import AltRouteIcon from "@mui/icons-material/AltRoute";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import BusinessIcon from "@mui/icons-material/Business";
import CasesIcon from "@mui/icons-material/CasesSharp";
import CategoryIcon from "@mui/icons-material/Category";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupIcon from "@mui/icons-material/Group";
import LinkIcon from "@mui/icons-material/Link";
import PersonIcon from "@mui/icons-material/Person";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import RateReviewIcon from "@mui/icons-material/RateReview";
import SchoolIcon from "@mui/icons-material/School";
import ShieldIcon from "@mui/icons-material/Shield";
import StorageIcon from "@mui/icons-material/Storage";
import VerifiedIcon from "@mui/icons-material/Verified";
import WorkspacePremiumIconRounded from "@mui/icons-material/WorkspacePremiumRounded";

import { AUTH_ROLES, PERMISSION_AREAS } from "api/common/types/auth.types";

import { SidebarOptionConfig, SIDEBAR_ITEM_TYPES } from "./sidebar.types";

const { NIAP, LAB, VALIDATOR, SME, VENDOR } = AUTH_ROLES;
const { NAV, COLLAPSIBLE } = SIDEBAR_ITEM_TYPES;

export const sidebarConfig: SidebarOptionConfig[] = [
  {
    type: NAV,
    icon: <DashboardIcon />,
    label: "Dashboard",
    link: "/community",
    allowedRoles: [NIAP, LAB, VALIDATOR, SME, VENDOR],
  },
  {
    type: NAV,
    icon: <CategoryIcon />,
    label: "Products",
    link: "/community/products",
    allowedRoles: [NIAP, LAB, VALIDATOR],
    requiredArea: PERMISSION_AREAS.PROJECT,
  },
  {
    type: NAV,
    icon: <ShieldIcon />,
    label: "Protection Profiles",
    link: "/community/protectionprofiles",
    allowedRoles: [NIAP, VALIDATOR],
    requiredArea: PERMISSION_AREAS.PROTECTION_PROFILE,
  },
  {
    type: NAV,
    icon: <QuestionAnswerIcon />,
    label: "Q&A",
    link: "/community/question-answer",
    allowedRoles: [NIAP],
  },
  {
    type: NAV,
    icon: <GroupIcon />,
    label: "Virtual Teams",
    link: "/community/virtualteams",
    allowedRoles: [NIAP, VALIDATOR],
    requiredArea: PERMISSION_AREAS.VIRTUAL_TEAMS,
  },
  {
    type: NAV,
    icon: <BusinessIcon />,
    label: "Organizations Manager",
    link: "/community/organizations",
    allowedRoles: [NIAP, LAB, VALIDATOR],
    requiredArea: PERMISSION_AREAS.ORGANIZATION,
  },
  {
    type: NAV,
    icon: <AltRouteIcon />,
    label: "TRRTs",
    link: "/community/technicalqueries",
    allowedRoles: [NIAP, LAB, VALIDATOR, SME],
    requiredArea: PERMISSION_AREAS.TECHNICAL_QUESTIONS,
  },
  {
    type: NAV,
    icon: <CasesIcon />,
    label: "International Posting Requests",
    link: "/community/pcm",
    allowedRoles: [NIAP],
  },
  {
    type: NAV,
    icon: <VerifiedIcon />,
    label: "Cert Reviews",
    link: "/community/nist",
    allowedRoles: [NIAP, LAB, VALIDATOR],
  },
  {
    type: NAV,
    icon: <BeenhereIcon />,
    label: "Technical Decisions",
    link: "/community/technical-decisions",
    allowedRoles: [NIAP, VALIDATOR, SME],
    requiredArea: PERMISSION_AREAS.TECHNICAL_DECISIONS,
  },
  {
    type: NAV,
    icon: <WorkspacePremiumIconRounded />,
    label: "EAR Reviews",
    link: "/community/ear-reviews",
    allowedRoles: [NIAP, VALIDATOR, SME],
    requiredArea: PERMISSION_AREAS.EAR_REVIEWS,
  },
  {
    type: NAV,
    icon: <RateReviewIcon />,
    label: "ECR Comments",
    link: "/community/ecr-comments",
    allowedRoles: [NIAP, LAB, VALIDATOR],
    requiredArea: PERMISSION_AREAS.ECR_COMMENTS,
  },
  {
    type: NAV,
    icon: <AssignmentIcon />,
    label: "Reports",
    link: "/community/reports",
    allowedRoles: [NIAP, VALIDATOR],
    requiredArea: PERMISSION_AREAS.PROJECT,
  },
  {
    type: NAV,
    icon: <StorageIcon />,
    label: "Document Manager",
    link: "/community/documents",
    allowedRoles: [NIAP, LAB, VALIDATOR],
    requiredArea: PERMISSION_AREAS.DOCUMENT_MANAGER,
  },
  {
    type: NAV,
    icon: <SchoolIcon />,
    label: "Training Center",
    link: "/community/training-center",
    allowedRoles: [NIAP, LAB, VALIDATOR, VENDOR],
  },
  {
    type: COLLAPSIBLE,
    icon: <LinkIcon />,
    label: "NIAP Quick Links",
    allowedRoles: [NIAP],
    children: [
      { label: "Approved External Links", link: "/community/external-links" },
      { label: "Events Manager", link: "/community/events-manager" },
      {
        label: "Announcements Manager",
        link: "/community/announcements-manager",
      },
      { label: "Glossary Manager", link: "/community/glossary-manager" },
      { label: "Frequently Asked Questions", link: "/community/faqs" },
      { label: "Labgrams Manager", link: "/community/labgrams-manager" },
      { label: "Policy Letters", link: "/community/policy-letters" },
      {
        label: "Document Serial Numbers",
        link: "/community/document-serial-numbers",
      },
      {
        label: "Technical Communities Manager",
        link: "/community/technical-communities",
      },
      { label: "Upload Atypical File", link: "/community/upload-atypical" },
      { label: "Site Settings", link: "/community/site-settings" },
    ],
  },
  {
    type: NAV,
    icon: <PersonIcon />,
    label: "Accounts",
    link: "/community/accounts",
    allowedRoles: [NIAP, LAB, VALIDATOR],
    requiredArea: PERMISSION_AREAS.ACCOUNTS,
  },
  {
    type: NAV,
    icon: <ContactMailIcon />,
    label: "Mailing Lists",
    link: "/community/mailing-lists",
    allowedRoles: [NIAP],
  },
];
